export enum CompanyCode {
    Sweden = "100",
    Norway = "210",
}
